export default ({rentals = []} = {}) =>
  rentals.find(({state}) => state === 'active');
